// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import useCollateralState from '../hooks/queries/collateral/collateral/useCollateralState';

interface Args {
  partyA: string;
  partyB: string;
  operator: string;
  id: string;
}
export const useGetCollateralState = () => {
  const collateralStates = useCollateralState();
  return (args: Args) =>
    (collateralStates.data || []).find(
      (cs) =>
        cs.payload.partyA === args.partyA &&
        cs.payload.partyB === args.partyB &&
        cs.payload.id === args.id &&
        cs.payload.operator === args.operator,
    );
};
